Ext.define('SA.ChartLegendModeButton', {
    alias: 'widget.chart-legend-mode-button',
    extend: 'SA.view.Button',

    cls: 'sa-chart-legend-mode-button',
    ui: undefined, 

    setIsSummaryMode(isSummaryMode) {
        this.setText(isSummaryMode ? 'Edit' : 'Done');
    }
});